export const isAadhaarMandatoryForOnboarding = (org, patientType) => {
  const onboarding = org?.isAadharNumberMandatory?.onboarding;

  // Backward compatibility for organizations still using "onboarding": true.
  if (typeof onboarding === "boolean") {
    return onboarding;
  }

  if (!onboarding || typeof onboarding !== "object") {
    return false;
  }

  const patientTypeSetting = onboarding[patientType];
  if (typeof patientTypeSetting === "boolean") {
    return patientTypeSetting;
  }

  return typeof onboarding.default === "boolean"
    ? onboarding.default
    : false;
};
